const getLoadingStatus = state => state.categoriesBasic.isLoading;

const getCategoriesBasic = state => state.categoriesBasic.categoriesBasic;

const getCategoryBasic = state => state.categoriesBasic.categoryBasic;

export { getLoadingStatus, getCategoriesBasic, getCategoryBasic };
